<template>
  <v-data-table
    :headers="headers"
    :items="images"
    class="elevation-0"
    disable-pagination
    hide-default-footer
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Images</v-toolbar-title>
        <v-spacer/>
        <v-btn color="success" dark class="mb-2" @click="openImageModal(title)">Add image</v-btn>
        <v-dialog v-model="dialogImage" max-width="700px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ editedImage.edit ? 'Edit' : 'Add' }} image</span>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="editedImage.lang_code"
                label="Language (code)"
                dense
                outlined
              />
              <v-file-input
                v-model="editedImage.img_file"
                label="Main image"
                dense
                outlined
                accept="image/png"
                prepend-icon="mdi-file-image"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                    color="primary"
                    dark
                    label
                    small
                  >
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
              <v-file-input
                v-model="editedImage.hover_file"
                label="Hover image"
                dense
                outlined
                accept="image/png"
                prepend-icon="mdi-file-image"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                    color="primary"
                    dark
                    label
                    small
                  >
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="primary" text @click="closeImageDialog">Cancel</v-btn>
              <v-btn color="primary" text @click="saveImage">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.default="{ item }">
      <v-checkbox
        v-model="item.default"
        class="ma-0 pa-0"
        hide-details
        label="use as default"
        @change="(e) => setDefaultLanguage(e, item)"
      />
    </template>
    <template v-slot:item.img="{ item }">
      <v-img
        :src="item.img"
        max-height="150"
        max-width="300"
        contain
        class="mx-auto"
      />
    </template>
    <template v-slot:item.hover="{ item }">
      <v-img
        :src="item.hover"
        max-height="150"
        max-width="300"
        contain
        class="mx-auto"
      />
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        @click="openEditImageModal(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        @click="deleteImage(item)"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
  props: {
    title: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialogImage: false,
      editedImage: {
        title_id: null,
        lang_code: null,
        img_file: null,
        hover_file: null
      },
      defaultImage: {
        title_id: null,
        lang_code: null,
        img_file: null,
        hover_file: null
      },
      headers: [
        {
          text: 'Language (code)',
          align: 'start',
          sortable: false,
          value: 'lang_code',
        },
        {
          text: 'Use as default',
          align: 'start',
          sortable: false,
          value: 'default',
        },
        {
          text: 'Main image',
          align: 'center',
          sortable: false,
          value: 'img'
        },
        {
          text: 'Hover image',
          align: 'center',
          sortable: false,
          value: 'hover'
        },
        {
          text: 'Actions',
          sortable: false,
          value: 'actions'
        }
      ]
    }
  },
  computed: {
    images() {
      return this.title.images.map(image => ({ ...image, hover: this.addUuid(image.hover), img: this.addUuid(image.img) }))
    }
  },
  methods: {
    openImageModal() {
      this.editedImage =  Object.assign({}, this.defaultImage);
      this.$nextTick(() => {
        this.dialogImage = true;
      });
    },
    openEditImageModal(item) {
      this.editedImage =  Object.assign({}, item, { edit: true });
      this.$nextTick(() => {
        this.dialogImage = true;
      });
    },
    closeImageDialog() {
      this.dialogImage = false;
      this.editedImage = Object.assign({}, this.defaultImage);
    },
    addUuid(src) {
      return src + '?hash=' + uuidv4();
    },
    async saveImage() {
      let formData = new FormData();
      formData.set('lang_code', this.editedImage.lang_code);
      formData.set('marketplace_id', this.$route.params.id);
      formData.set('default', this.editedImage.default);
      formData.append('files', this.editedImage.img_file);
      formData.append('files', this.editedImage.hover_file);
      try {
        let { data } = await this.$axios.post('/api/title/' + this.title.title_id + '/image', formData, {
          headers: {
            'content-type': 'multipart/form-data'
          }
        });
        if (this.editedImage.edit) {
          const index = this.images.findIndex(image => image.img === this.editedImage.img);
          this.$set(this.title.images, index, data);
        } else {
          this.title.images.push(data);
        }
        
        this.$toasted.success('Image uplodaed');
        this.closeImageDialog();
      } catch(err) {
        this.$toasted.error(err.message);
      }
    },
    async deleteImage(item) {
      try {
        await this.$axios.delete(item.img);
        const index = this.images.findIndex(image => image.img === item.img);
        this.$delete(this.title.images, index);
        this.$toasted.success('Image removed');
      } catch(err) {
        this.$toasted.error(err.message);
      }
    },
    setDefaultLanguage(e, item) {
      if (e) {
        this.title.images = this.title.images.map(image => 
        ({
          ...image,
          default: image.lang_code === item.lang_code
        }));

        this.$axios.put('/api/title/', {
          marketplace_id: this.$route.params.id,
          lang_code: item.lang_code,
          title_id: this.title.title_id
        }).catch(err => console.warn(err.message))
      }
    },
  }
}
</script>